import { CalendarDays } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Section, LockedRow } from "@/components/plan/common";

export default function ContentCalendarSection({ calendar, isFree }) {
  if (!calendar?.length) return null;
  const shown = calendar.slice(0, isFree ? 7 : undefined);
  return (
    <Section icon={CalendarDays} title="30-day content calendar">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {shown.map((d, i) => (
          <div key={`cal-day-${d.day ?? i}`} className="bg-white border border-zinc-200 rounded-xl p-4 print-avoid-break">
            <div className="flex items-center justify-between">
              <div className="text-xs uppercase tracking-widest text-zinc-400">Day {d.day}</div>
              <Badge variant="outline" className="text-[10px]">{d.channel}</Badge>
            </div>
            <div className="font-medium text-sm mt-2">{d.topic}</div>
            <div className="text-xs text-zinc-500 mt-1">{d.format}</div>
            <div className="text-xs text-indigo-600 mt-2">CTA: {d.cta}</div>
          </div>
        ))}
      </div>
      {isFree && calendar.length > 7 && (
        <div className="mt-4"><LockedRow message={`Days 8–${calendar.length} available on the paid plan`} /></div>
      )}
    </Section>
  );
}
